import React from 'react';
import { FadeIn } from './FadeIn';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'María Fernanda G.',
    location: 'Buenos Aires, Argentina',
    avatar: 'MF',
    color: 'bg-rose-100 text-rose-700',
    text: 'Llevaba 3 años haciendo scrapbook y nunca había podido terminar un álbum completo. Con el Tomo 2 entendí por qué mis tapas se curvaban y lo resolví en una tarde. Ahora tengo 4 álbumes terminados.',
    stars: 5
  }, {
    name: 'Valentina R.',
    location: 'Córdoba, Argentina',
    avatar: 'VR',
    color: 'bg-violet-100 text-violet-700',
    text: 'Doy talleres de encuadernación y este bundle me dio contenido para todo el año. El Tomo 3 solo vale más que cualquier curso que haya pagado antes. Mis alumnas no pueden creer la calidad del material.',
    stars: 5
  }, {
    name: 'Camila S.',
    location: 'Monterrey, México',
    avatar: 'CS',
    color: 'bg-amber-100 text-amber-700',
    text: 'Lo que más me sorprendió fue el Tomo 6: la fórmula de precio me abrió los ojos. Estaba cobrando $15 USD por álbumes que debían costar $75. Ya los vendí a precio justo y los clientes ni pestañearon.',
    stars: 5
  }, {
    name: 'Luciana P.',
    location: 'Santiago, Chile',
    avatar: 'LP',
    color: 'bg-emerald-100 text-emerald-700',
    text: 'El Sistema de 7 Capas del Tomo 4 me cambió la manera de ver el art journal. Mis páginas pasaron de verse amateur a nivel galería en literalmente 2 semanas de práctica.',
    stars: 5
  }];
  return <section className="py-16 sm:py-24 px-5 bg-brand-paper border-y border-brand-line" data-id="element-211">
      <div className="max-w-6xl mx-auto" data-id="element-212">
        <FadeIn className="text-center mb-12 sm:mb-16" data-id="element-213">
          <span className="inline-block text-brand-gold font-bold tracking-widest text-xs uppercase mb-4 border border-brand-gold/30 px-3 py-1 rounded-full" data-id="element-214">
            Lo que dicen las crafteras
          </span>
          <h3 className="text-3xl sm:text-5xl font-black text-brand-ink mt-4" data-id="element-215">
            Resultados reales.
            <br data-id="element-216" />
            Crafteras reales.
          </h3>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-217">
          {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-218">
              <div className="bg-brand-cream border border-brand-line rounded-2xl p-6 sm:p-7 h-full flex flex-col" data-id="element-219">
                <div className="flex items-center gap-1 mb-4" data-id="element-220">
                  {[...Array(t.stars)].map((_, j) => <StarIcon key={j} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-221" />)}
                </div>
                <p className="text-brand-ink text-sm sm:text-base leading-relaxed flex-1 mb-6" data-id="element-222">
                  "{t.text}"
                </p>
                <div className="flex items-center gap-3 pt-5 border-t border-brand-line" data-id="element-223">
                  <div className={`w-10 h-10 rounded-full ${t.color} flex items-center justify-center font-black text-sm`} data-id="element-224">
                    {t.avatar}
                  </div>
                  <div data-id="element-225">
                    <p className="text-brand-ink font-bold text-sm" data-id="element-226">{t.name}</p>
                    <p className="text-brand-muted text-xs" data-id="element-227">{t.location}</p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}